import { z } from 'zod';

export const IPostCreatePlaidTokenResultSchema = z.object({
  link_token: z.string(),
});

export type IPostCreatePlaidTokenResult = z.infer<
  typeof IPostCreatePlaidTokenResultSchema
>;

export interface IPostCreatePlaidParams {
  currency: string;
  payment_network: string;
}
